import { MOBILE_WEB_URL } from 'common/constants'
import isMobile from 'is-mobile'
// import withGrant from 'lib/auth/with-grant'
import { composeUrlParameter } from 'lib/transform/query-string'
import { GetServerSideProps } from 'next'
import SearchResult from 'services/LocalStorefront/screens/SearchResult'

// disable server side grant middleware
// export default withGrant(SearchResult)

export const getServerSideProps: GetServerSideProps = async ({
  req,
  query,
}) => {
  const userAgent = req.headers['user-agent']
  if (isMobile({ ua: userAgent })) {
    return {
      redirect: {
        destination: `${MOBILE_WEB_URL}/local-store/search${composeUrlParameter(
          query,
        )}`,
        permanent: false,
      },
    }
  }

  return {
    props: {},
  }
}

export default SearchResult
